import type { MarketplaceErrorRes } from '@dvb/common';

import { BaseErrorLayout } from '@dvb/ui';
import { HeaderBar } from '@school-manage/ui/HeaderBar/HeaderBar';
import { getRouteApi } from '@tanstack/react-router';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const route = getRouteApi('/_authed/task/$taskId_/sport');

export function SportDetailError({
  error,
}: {
  error: Error | MarketplaceErrorRes;
}) {
  const { t } = useTranslation();
  const navigate = route.useNavigate();
  const { taskId } = route.useParams();

  const { description, title } = useMemo(() => {
    if ('code' in error && error.code === 2001) {
      return {
        description: t('notFoundDes', { name: t('sports') }),
        title: t('notFound', { name: t('sports') }),
      };
    }
    return { description: '', title: '' };
  }, [error, t]);

  return (
    <>
      <HeaderBar
        backBtnHandler={() =>
          navigate({
            params: { taskId },
            replace: true,
            to: '/task',
          })
        }
        hasBackBtn
        title={t('sports')}
      />
      <BaseErrorLayout
        className="bg-background w-full"
        description={description}
        title={title}
      />
    </>
  );
}
